<template>

  <v-dialog v-model="dialog" scrollable width="800px">
    <v-card>

      <v-card color="transparent" flat>
        <v-card-text class="font-weight-light text-xs-left title  bluetext">
          Fügen Sie eine Web Adresse hinzu
        </v-card-text>
      </v-card>
      <v-card-text>
        <v-col cols="12">
          <v-text-field
                  color="cyan darken-3"
                  clearable
                  v-model="url"
                  label="Web Adresse"
                  outlined
          ></v-text-field>
        </v-col>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="doCancel()" color="cyan darken-3" small dark outlined
               class="radiusBtn text-none">Abbrechen
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="doSave()" color="cyan darken-3" small dark
               class="radiusBtn text-none">Speichern
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  //import Vue from 'vue'

  export default {
    name: 'DialogAddWeb',
    components: {},
    methods: {
      /**
       * newName, title, type
       * @param cardConfig
       */
      doCancel: function () {
        this.dialog = false
        this.$emit('cancel', null)
      },
      doSave: function () {
        this.dialog = false
        var cmp = this
        this.$emit('save', {
          url: cmp.url
        })
      },
      open: function (cardConfig) {
        if ((cardConfig != null) && (cardConfig)) {
          this.title = cardConfig.title
          this.description = cardConfig.description
        }
        this.dialog = true
      }
    },
    data () {
      return {
        url: 'https://www.',
        title: 'Login nicht erfolgreich',
        description: 'Wir konnten die Kombination aus Username und Passwort nicht validieren',
        dialog: false
      }
    },
    mounted () {
    }
  }
</script>

<style scoped>

</style>
